import { createSlice } from "@reduxjs/toolkit";
import { getAppliedHistoryByUser, getUsers } from "./thunk";

export interface IState {
  users: any;
  isUserLoading: boolean;
  isUserSuccess: boolean;

  workHistories: any,
  isWorkHistoryLoading: boolean,
  isWorkHistorySuccess: boolean,

  appliedHistories: any,
  isAppliedHistoryLoading: boolean,
  isAppliedHistorySuccess: boolean,

  error: any;
}

export const initialState: IState = {
  users: null,
  isUserLoading: false,
  isUserSuccess: false,

  workHistories: null,
  isWorkHistoryLoading: false,
  isWorkHistorySuccess: false,


  appliedHistories: null,
  isAppliedHistoryLoading: false,
  isAppliedHistorySuccess: false,

  error: {},
};

const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Users
    builder.addCase(getUsers.pending, (state: IState, action: any) => {
      state.isUserLoading = true;
    });
    builder.addCase(getUsers.fulfilled, (state: IState, action: any) => {
      state.users = action.payload.data;
      state.isUserSuccess = true;
      state.isUserLoading = false;
    });
    builder.addCase(getUsers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isUserSuccess = false;
      state.isUserLoading = false;
    });

    //get applied history
    builder.addCase(getAppliedHistoryByUser.pending, (state: IState, action: any) => {
      state.isAppliedHistoryLoading = true;
    });
    builder.addCase(getAppliedHistoryByUser.fulfilled, (state: IState, action: any) => {
      state.appliedHistories = action.payload.data;
      state.isAppliedHistorySuccess = true;
      state.isAppliedHistoryLoading = false;
    });
    builder.addCase(getAppliedHistoryByUser.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isAppliedHistorySuccess = false;
      state.isAppliedHistoryLoading = false;
    });
  },
});

export default UserSlice.reducer;